var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"eb0964337f9a69c038460cadb282cb824eb2195c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["busbud-pubweb-prod@busbudcom"]={id:"eb0964337f9a69c038460cadb282cb824eb2195c"};
      